export var AttackResultType;
(function (AttackResultType) {
    AttackResultType["Normal"] = "normal";
    AttackResultType["BattleBack"] = "battleBack";
})(AttackResultType || (AttackResultType = {}));
